module.exports = __webpack_public_path__ + "static/media/15.441b57b5.jpg";